// src/App.tsx
import React from "react";
import { CssBaseline, CssVarsProvider } from "@axtria/design-system-react";
import Layout from "./Layout";
import { useUserProfile } from "./utils/hooks/useUserProfile";
const App: React.FC = () => {
  useUserProfile();
  return (
    <CssVarsProvider>
      <CssBaseline />
      <Layout />
    </CssVarsProvider>
  );
};

export default App;
